import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterConstants } from "../../../../../redux/constants";
import CustomCheckBox from "../../../../customCheckBox";
import { useTranslation } from "react-i18next";
const { BROWNIE } = filterConstants;

const BrownieFilter = ({ applyFilter, fabric }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const _filter = useSelector((state) => state.filter);
  const applyBrownie = (check) => {
    dispatch({
      type: BROWNIE,
      payload: check,
    });
    applyFilter(4, check && new fabric.Image.filters.Brownie());
  };
  return (
    <div>
      <CustomCheckBox
        lable={t("BrownieFilter.Brownie")}
        checked={_filter.brownie}
        onClick={(e) => applyBrownie(e.target.checked)}
      />
    </div>
  );
};

export default BrownieFilter;
